import {
    type PaycheckRoutingConfig,
    type PaycheckRoutingRule,
} from './PaycheckRouting';

export interface IncomeSplitAccount {
    id?: string;
    paycheckRoutingConfigId?: string;
    accountId: string;
}

export enum IncomeSplitRuleType {
    MINIMUM_BALANCE = 'MINIMUM_BALANCE',
    PERCENTAGE = 'PERCENTAGE',
}

export enum IncomeSplitRuleContributionType {
    MAXIMIZE_CONTRIBUTIONS = 'MAXIMIZE_CONTRIBUTIONS',
    PERCENTAGE_OF_REMAINDER = 'PERCENTAGE_OF_REMAINDER',
}

export const IncomeSplitRuleContributionTypeNames: Record<string, string> = {
    [IncomeSplitRuleContributionType.MAXIMIZE_CONTRIBUTIONS]:
        'Maximize contributions',
    [IncomeSplitRuleContributionType.PERCENTAGE_OF_REMAINDER]:
        'Percentage of remainder',
};

export const IncomeSplitRuleContributionTypeDescriptions: Record<
    string,
    string
> = {
    [IncomeSplitRuleContributionType.MAXIMIZE_CONTRIBUTIONS]:
        '100% of available/remaining funds',
    [IncomeSplitRuleContributionType.PERCENTAGE_OF_REMAINDER]:
        'Specified portion of available/remaining funds',
};

export const IncomeSplitRuleNames: Record<string, string> = {
    [IncomeSplitRuleType.MINIMUM_BALANCE]: 'Build up target balance',
    [IncomeSplitRuleType.PERCENTAGE]: 'Contribute indefinitely',
};

export const IncomeSplitRuleDescriptions: Record<string, string> = {
    [IncomeSplitRuleType.MINIMUM_BALANCE]:
        'Contribute until a specified target account balance is reached',
    [IncomeSplitRuleType.PERCENTAGE]:
        'Continue contributions unless otherwise specified',
};

export type IncomeSplitRuleLegacy = Omit<PaycheckRoutingRule, 'type'> & {
    type?: IncomeSplitRuleType;
    percentage?: number | null;
    monthlyContributionMaxCents?: number;
    yearlyContributionMaxCents?: number;
    isExternal?: boolean;
};

export type IncomeSplitConfigLegacy = Omit<
    PaycheckRoutingConfig,
    'id' | 'accountId' | 'originator' | 'receiver' | 'rules'
> & {
    id?: string;
    onlyExecuteOnPaychecks: boolean;
    accounts: IncomeSplitAccount[];
    rules: IncomeSplitRuleLegacy[];
    isNew?: boolean;
    isLegacy?: boolean;
};

export type IncomeSplitReviewContext = 'edit' | 'review';

export type IncomeSplitContext = 'incomeSplit' | 'goButtonFlow';
